<template>
  <div class="yxtbiz-dimension">
    <p class="dimtitle mb16" @click="addGroup">
      {{
        isSingle
          ? '+ ' + $t('pc_spmodel_biz_10')
          : '+ ' + $t('pc_spmodel_biz_11')
      }}
    </p>
    <dimline
      ref="dimline"
      :anded.sync="ruleConfig.logic"
      :isGray="false"
      :isShow="ruleConfig.conditions && ruleConfig.conditions.length > 1"
    >
      <div class="dimension-content dimension-c">
        <div
          v-for="(item, index) in ruleConfig.conditions"
          class="bgray pl16 pt16"
          :class="{
            pl8: item.rules.length === 1
          }"
          :key="index"
        >
          <dimline
            :num="index"
            :anded.sync="item.logic"
            :ref="'dimline1' + index"
            :isShow="item.rules.length > 1"
            :isGray="true"
          >
            <div class="dimension-c">
              <!-- :class="{
                  mb16: i + 1 < item.rules.length && !value.description,
                  mb16: value.description
                }" -->
              <div
                :class="{
                  mb20: i + 1 < item.rules.length && !value.description,
                  mb16: i + 1 < item.rules.length && value.description
                }"
                v-for="(value, i) in item.rules"
                :key="i"
              >
                <yxt-select
                  v-model="value.type"
                  v-if="value.type !== 3 && !isDataModel"
                  filterable
                  :placeholder="$t('pc_spmodel_biz_select')"
                  size="small"
                  class="w74 mr12"
                  @change="typeChangeFn(index, i)"
                >
                  <yxt-option
                    v-for="option in type"
                    :key="option.id"
                    :label="option.label"
                    :value="option.id"
                  />
                </yxt-select>
                <template v-if="value.type === 1">
                  <target-rule
                    :ref="'targetrule-' + index + '-' + i"
                    :uselocalStorage="true"
                    :type1="type1"
                    :value.sync="ruleConfig.conditions[index].rules[i]"
                  />
                </template>
                <!--:uselocalStorage="!item.isfirst" -->
                <template v-if="value.type === 2">
                  <label-rule
                    :ref="'labelrule-' + index + '-' + i"
                    :uselocalStorage="true"
                    :type2="type2"
                    :value.sync="ruleConfig.conditions[index].rules[i]"
                  />
                </template>
                <template v-if="value.type === 3">
                  <target-rule
                    :isDataModel="isDataModel"
                    :ref="'targetrule-' + index + '-' + i"
                    :uselocalStorage="true"
                    :type1="type3"
                    :value.sync="ruleConfig.conditions[index].rules[i]"
                  />
                </template>
                <yxt-svg
                  width="20px"
                  height="20px"
                  icon-class="delete"
                  @click.native="delFn(index, i)"
                  style="vertical-align: middle; margin-left: -4px"
                  class="hand color-gray-9 p2 hover-bg-gray-3"
                />
                <unusual
                  v-if="
                    !isDataModel &&
                      Number(ruleConfig.conditions[index].rules[i].state) > 0 &&
                      Number(ruleConfig.conditions[index].rules[i].state) < 5
                  "
                  :content="
                    value.type === 1
                      ? targetcontent[
                          ruleConfig.conditions[index].rules[i].state
                        ]
                      : labelcontent[
                          ruleConfig.conditions[index].rules[i].state
                        ]
                  "
                />
                <!-- 指标里字段异常  不写！== 0 是为了排查null的场景-->
                <unusual
                  v-if="
                    isDataModel &&
                      Number(ruleConfig.conditions[index].rules[i].state) > 0 &&
                      Number(ruleConfig.conditions[index].rules[i].state) < 5
                  "
                  :content="$t('pc_spmodel_data_unuse')"
                />
                <yxt-tooltip
                  v-if="value.description"
                  :content="value.description"
                  placement="left"
                  open-filter
                >
                  <div
                    class="ellipsis mt8"
                    style="
                      line-height: 14px;
                      color: #595959;
                      font-size: 12px;
                      margin-top: 6px;
                      max-width: 200px;
                    "
                  >
                    {{ value.description }}
                  </div>
                </yxt-tooltip>
              </div>
            </div>
          </dimline>
          <div
            v-if="!isSingle"
            class="dimtitle mt12 dimtitle1"
            :class="{
              ml32: item.rules.length !== 1,
              mb16: ruleConfig.conditions.length !== index + 1
            }"
            @click="addItem(index)"
          >
            + {{ $t('pc_spmodel_biz_10') }}
          </div>
        </div>
      </div>
    </dimline>
  </div>
</template>

<script>
import dimline from './components/dimline.vue';
import unusual from './components/unusual.vue';
import targetRule from './components/targetRule.vue';
import labelRule from './components/labelRule.vue';
import handleError from './components/handleError';
import {
  getTargetList,
  getLabelCompList,
  ruleCreate,
  getRule,
  delCreate,
  ruleEdit,
  metacolumnSelect
} from './service.js';
import { i18n } from 'yxt-biz-pc/packages/common-util/changeLangs';
const condition = {
  rules: [
    {
      type: 1,
      id: null,
      name: null,
      columnType: null,
      targetDesc: null,
      operators: [
        {
          operateType: null,
          operatorCnName: null,
          value: null
        }
      ]
    }
  ],
  logic: 1
};
const citem = {
  type: 1,
  id: null,
  name: '',
  columnType: null,
  targetDesc: '',
  operators: [
    {
      operateType: null,
      operatorCnName: null,
      value: null
    }
  ]
};
export default {
  name: 'YxtbizDimension',
  name_zh: '创建标签规则',
  components: {
    dimline,
    unusual,
    targetRule,
    labelRule
  },
  mixins: [handleError],
  data() {
    return {
      type: [
        {
          id: 1,
          label: i18n.t('pc_spmodel_the_zhibiao')
        },
        {
          id: 2,
          label: i18n.t('pc_spmodel_the_label')
        }
      ],
      selectindex: 0,
      type1: [],
      type2: [],
      type3: [], // 数据表selectlist
      targetcontent: [
        '',
        i18n.t('pc_spmodel_label_err_1'),
        i18n.t('pc_spmodel_label_err_2'),
        i18n.t('pc_spmodel_label_err_2'),
        i18n.t('pc_spmodel_label_err_3')
      ],
      labelcontent: [
        '',
        i18n.t('pc_spmodel_label_err_4'),
        i18n.t('pc_spmodel_label_err_5'),
        i18n.t('pc_spmodel_label_err_6'),
        i18n.t('pc_spmodel_label_err_7')
      ]
    };
  },
  eventList: [],
  slots: [],
  props: {
    ruleConfig: {
      type: Object,
      default: () => {
        return {
          conditions: [],
          logic: 1
        };
      },
      desc: '标签规则',
      setter: 'JsonSetter'
    },
    isSingle: {
      // 为徐峰提供的是否为非嵌套模式
      type: Boolean,
      default: false,
      desc: '是否单层模式',
      setter: 'BooleanSetter'
    },
    appCode: {
      type: String,
      default: '',
      desc: '业务类型',
      setter: 'StringSetter'
    },
    ruleId: {
      type: String,
      default: '',
      desc: '规则Id',
      setter: 'StringSetter'
    },
    isDataModel: {
      // 为建立指标规则设立的数据规则模式
      type: Boolean,
      default: false,
      desc: '是否数据规则模式',
      setter: 'BooleanSetter'
    },
    tableId: {
      // 指标规则里的tableid
      type: String,
      default: '',
      desc: '指标规则里的tableid',
      setter: 'StringSetter'
    },
    dimTypeId: {
      // 指标维度ID, 默认查询人员维度
      type: String,
      default: '',
      desc: '指标维度ID',
      setter: 'StringSetter'
    }
  },
  mounted() {
    let arryFn = this.isDataModel
      ? [this.metacolumnSelect()]
      : [this.getLabelListFn(), this.getTargetList()];
    Promise.all(arryFn).then(() => {
      // 主动传入的ruleConfig 优先
      if (
        this.ruleId &&
        this.ruleConfig &&
        this.ruleConfig.conditions &&
        this.ruleConfig.conditions.length === 0
      ) {
        this.getRuleFn();
      }
    });
  },
  watch: {
    ruleId() {
      // 为许斌定制的逻辑
      if (
        this.ruleId &&
        this.ruleConfig &&
        this.ruleConfig.conditions &&
        this.ruleConfig.conditions.length === 0
      ) {
        this.getRuleFn();
      } else {
        this.ruleConfig = {
          conditions: [],
          logic: 1
        };
      }
    }
  },
  methods: {
    getRuleFn() {
      getRule({ id: this.ruleId, params: { appCode: this.appCode } })
        .then(res => {
          this.ruleConfig = res.ruleConfig;
        })
        .catch(err => {
          this.handleError(err);
        });
    },
    delCreate() {
      return new Promise((resolve, reject) => {
        delCreate({ id: this.ruleId, params: { appCode: this.appCode } })
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            this.handleError(err);
            reject(err);
          });
      });
    },
    getValue() {
      let newValue = JSON.parse(JSON.stringify(this.ruleConfig));
      newValue.conditions &&
        newValue.conditions.forEach(element => {
          element.rules.forEach(item => {
            if (item.operators[0].operateType === 20) {
              item.operators = [
                {
                  operateType: 5,
                  operatorCnName: 'pc_spmodel_eq_5',
                  value: item.operators[0].values[0]
                },
                {
                  operateType: 6,
                  operatorCnName: 'pc_spmodel_eq_6',
                  value: item.operators[0].values[1]
                }
              ];
            }
            if (item.operators[0].values) {
              delete item.operators[0].values;
            }
          });
        });
      return newValue;
    },
    validateFn() {
      return new Promise((resolve, reject) => {
        let promiseArray = [];
        this.ruleConfig.conditions.forEach((item, index) => {
          item.rules.forEach((value, i) => {
            if (value.type === 1 || value.type === 3) {
              promiseArray.push(
                this.$refs['targetrule-' + index + '-' + i][0].validateFn()
              );
            } else if (value.type === 2) {
              promiseArray.push(
                this.$refs['labelrule-' + index + '-' + i][0].validateFn()
              );
            }
          });
        });
        Promise.all(promiseArray)
          .then(value => {
            console.log(value);
            resolve(true);
          })
          .catch(() => {
            reject(false);
          });
      });
    },
    saveRuleFn() {
      return new Promise((resolve, reject) => {
        this.validateFn()
          .then(() => {
            if (this.appCode && !this.ruleId) {
              let pramas = {
                appCode: this.appCode,
                ruleConfig: this.getValue()
              };
              ruleCreate(pramas)
                .then(res => {
                  resolve(res.id);
                })
                .catch(err => {
                  reject(err);
                  this.handleError(err);
                });
            } else if (this.appCode && this.ruleId) {
              let params = {
                appCode: this.appCode,
                ruleConfig: this.getValue()
              };
              ruleEdit({ id: this.ruleId, params: params })
                .then(() => {
                  resolve(this.ruleId);
                })
                .catch(err => {
                  reject(err);
                  this.handleError(err);
                });
            }
          })
          .catch(() => {
            this.$message.warning(this.$t('pc_spmodel_pl_build_45'));
            reject();
          });
      });
    },
    getLabelListFn() {
      return new Promise((resolve, reject) => {
        let params = {};
        this.dimTypeId && (params.dimTypeId = this.dimTypeId);
        getLabelCompList(params)
          .then(res => {
            if (res && res.length > 0) {
              this.type2 = res;
            }
            resolve();
          })
          .catch(err => {
            reject();
            this.handleError(err);
          });
      });
    },
    getTargetList() {
      return new Promise((resolve, reject) => {
        let params = {};
        this.dimTypeId && (params.dimTypeId = this.dimTypeId);
        getTargetList(params)
          .then(res => {
            if (res && res.length > 0) {
              this.type1 = res;
            }
            resolve();
          })
          .catch(err => {
            this.handleError(err);
            reject();
          });
      });
    },
    metacolumnSelect() {
      return new Promise((resolve, reject) => {
        metacolumnSelect({
          searchVal: '',
          tableId: this.tableId,
          type: 0
        })
          .then(res => {
            if (res && res.length > 0) {
              this.type3 = [];
              res.forEach(res => {
                this.type3.push({
                  disabled: res.disabled || 0,
                  name: res.columnByName || res.columnName,
                  id: res.id,
                  enums: res.enums || [],
                  columnType: res.columnType === null ? 4 : res.columnType
                  // state: res.state || 1,
                });
              });
            }
            resolve();
          })
          .catch(err => {
            this.handleError(err);
            reject();
          });
      });
    },
    delFn(index, i) {
      if (this.ruleConfig.conditions[index].rules.length > 1) {
        this.ruleConfig.conditions[index].rules.splice(i, 1);
        this.resetheight(index, i);
      } else {
        this.ruleConfig.conditions.splice(index, 1);
        this.resetheight(index);
      }
    },
    addGroup() {
      if (this.ruleConfig.conditions.length > 9) {
        this.$message.warning(this.$t('pc_spmodel_biz_13'));
        return;
      }
      if (this.isDataModel) {
        condition.rules[0].type = 3;
      } else {
        condition.rules[0].type = 1;
      }
      this.ruleConfig.conditions.push(JSON.parse(JSON.stringify(condition)));
      this.resetheight(1);
    },
    addItem(i) {
      if (this.ruleConfig.conditions[i].rules.length > 9) {
        this.$message.warning(this.$t('pc_spmodel_biz_14'));
        return;
      }
      if (this.isDataModel) {
        citem.type = 3;
      } else {
        citem.type = 1;
      }
      this.ruleConfig.conditions[i].rules.push(
        JSON.parse(JSON.stringify(citem))
      );
      this.resetheight(i);
    },
    resetheight(index = '', i) {
      if (this.ruleConfig.conditions.length === 1) {
        this.$refs['dimline1' + index] &&
          this.$refs['dimline1' + index][0] &&
          this.$refs['dimline1' + index][0].reSetHeight();
      } else {
        this.$refs.dimline.reSetHeight();
      }
    },
    typeChangeFn(index, i) {
      this.ruleConfig.conditions[index].rules[i].id = '';
      this.ruleConfig.conditions[index].rules[i].name = '';
      this.ruleConfig.conditions[index].rules[i].description = '';
      this.ruleConfig.conditions[index].rules[i].columnType = '';
      this.ruleConfig.conditions[index].rules[i].operators[0].operateType = '';
      this.ruleConfig.conditions[index].rules[i].operators[0].operatorCnName =
        '';
      this.ruleConfig.conditions[index].rules[i].operators[0].value = [];
    }
  }
};
</script>

<style lang="scss" scoped>
.dimtitle {
  width: 160px;
  height: 22px;
  font-size: 14px;
  font-weight: 400;
  color: #436bff;
  line-height: 22px;
  cursor: pointer;
}
.dimtitle1 {
  height: 36px;
}
.w104 {
  width: 104px;
}

.w182 {
  width: 182px;
}

.w74 {
  width: 74px;
}

.bgray {
  background: #f9f9f9;
  border-radius: 5px;
}
</style>

<!-- 显示文本输入框：1.是指标2.columnType为1
显示数值：1.是指标2.columnType为2，3
单选：1.指标 columnType为0且operateType 为1，2，3，4，5，6
           2.标签labelType=1；operateType 为1，2，3，4，5，6
多选：1.指标 ===0 2.标签operateType 为7，8，9
日期：1.指标 columnType为4



数据类型对应符号：
指标：
0-枚举：7-包含其一、8-不包含、9-全部包含、1-等于、3-大于、4-小于、5-大于等于、6-小于等于
1-文本：1-等于、2-不等于、10-文本包含、11-文本不包含
2-整数
3-浮点数
4-日期：1-等于、2-不等于、3-大于、4-小于、5-大于等于、6-小于等于（区间即大于等于和小于等于两条）



标签：7-包含其一、8-不包含、9-全部包含、1-等于、3-大于、4-小于、5-大于等于、6-小于等于 -->
